import { render, staticRenderFns } from "./productDevelopment.vue?vue&type=template&id=6b7eb16a&scoped=true&"
import script from "./productDevelopment.vue?vue&type=script&lang=js&"
export * from "./productDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./productDevelopment.vue?vue&type=style&index=0&id=6b7eb16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7eb16a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7eb16a')) {
      api.createRecord('6b7eb16a', component.options)
    } else {
      api.reload('6b7eb16a', component.options)
    }
    module.hot.accept("./productDevelopment.vue?vue&type=template&id=6b7eb16a&scoped=true&", function () {
      api.rerender('6b7eb16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/productDevelopment.vue"
export default component.exports